const WORDS_PER_MINUTE = 200

/**
 * Estimates read time from an HTML or plain-text string.
 * Strips HTML tags before counting so rich-text CMS content works correctly.
 */
export const getReadTime = (content: string): string => {
  const text = content.replace(/<[^>]+>/g, ' ')
  const words = text.trim().split(/\s+/).filter(Boolean).length
  const minutes = Math.max(1, Math.round(words / WORDS_PER_MINUTE))

  return `${minutes} min read`
}
